/* RESPONSIBLE TEAM: team-automation-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';

const FollowUpRulesLengthIsValid = BaseValidator.extend({
  intl: service(),

  validate(value, options, model) {
    if (value.length) {
      return true;
    }

    if (options.message) {
      return this.intl.t(options.message);
    } else {
      return this.intl.t('validations.follow-up-rules-length.at-least-one-rule');
    }
  },
});

FollowUpRulesLengthIsValid.reopenClass({
  getDependentsFor() {
    return ['model.followUpRules'];
  },
});

export default FollowUpRulesLengthIsValid;
